import './TopBanner.css'

export default function TopBanner() {
  return (
    <div className="top-banner">
      <div className="top-banner-container">
        <div className="top-banner-content">
          <span className="top-banner-text">
            씨피엔터테인먼트
          </span>
        </div>
      </div>
    </div>
  )
}
